import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=35d4408e&scoped=true&"
import script from "./ComponentHeader.vue?vue&type=script&lang=js&"
export * from "./ComponentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentHeader.vue?vue&type=style&index=0&id=35d4408e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4408e",
  null
  
)

export default component.exports